import { ModalFormFieldContact } from "@complex/Contact/Dropdown";
import { type Control, Controller } from "react-hook-form";
import type { TTrainingSharedFormFieldValues } from "../types";
import { type ITrainingSharedFormSectionProps, getContactErrors } from "./shared";

interface ITrainingSharedFormContactProps<TForm extends TTrainingSharedFormFieldValues>
  extends ITrainingSharedFormSectionProps<TForm> {
  control: Control<TForm>;
}

export const TrainingSharedFormContact = <TForm extends TTrainingSharedFormFieldValues>({
  control,
  fields,
}: ITrainingSharedFormContactProps<TForm>) => {
  return (
    <Controller
      name={fields.contact}
      control={control}
      render={({ field: { value, onChange }, formState: { errors } }) => (
        <ModalFormFieldContact value={value} onChange={onChange} errors={getContactErrors(errors)} />
      )}
    />
  );
};
